import PropTypes from "prop-types";
import styles from "./style.module.scss";
import {Card} from 'antd'

const Cards = (props) => {
  return (
    <Card className={styles.card}>
      <h3 className={styles.text}>{props.title}</h3>
      <div className={styles.children}>
      {props.children}
      </div>
    </Card>
  );
};

export default Cards;
